import _ from 'lodash';

export function hasIntersection(arr1 = [], arr2 = []) {
  return _.intersection(arr1, arr2).length > 0;
}
export const isLastItem = (idx, items = []) => items.length === idx + 1;
export const isFirstItem = (idx) => idx === 0;
